var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "users_filter",
        "no-close-on-backdrop": true,
        size: "xl",
        title: "Редагування",
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ ok, cancel }) {
            return [
              _vm.show_action
                ? _c("b-spinner", { attrs: { variant: "success" } })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "btn btn-lg waves-effect waves-themed mr-3",
                  attrs: { size: "xl", variant: "outline-primary" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.close_editor()
                    },
                  },
                },
                [
                  _c("i", { staticClass: "fal fa-check mr-1" }),
                  _vm._v("\n            Гаразд\n        "),
                ]
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c("vue-editor", {
            attrs: { "editor-toolbar": _vm.editor_rules, id: "current_text" },
            model: {
              value: _vm.text_ed,
              callback: function ($$v) {
                _vm.text_ed = $$v
              },
              expression: "text_ed",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }